import React from 'react'
import { ToggledStyled, ToggledStyledContainer } from './styled'
import theme from 'config/theme'

export default function ToggledSideBar(props) {
	return (
		<>
			<ToggledStyledContainer>
				<ToggledStyled theme={theme} visibleBlock={props.showBlock} >
					{props.children}
				</ToggledStyled>
				<button type='button' onClick={() => props.setShowBlock(prev => !prev)} className='toggleBtn'>{props.showBlock ? <b>&#10216;</b> : <b>&#10217;</b>}</button>
			</ToggledStyledContainer>
		</>
	)
}
